import { Component, OnInit, ViewChild, ElementRef, Renderer2, Inject } from '@angular/core';
import { ApiService } from './shared/service/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { LocalStorageService } from './shared/service/localstorage.service';
import { Account, DeliveryAddress } from './account/account';
import { UserService } from './shared/service/user.service';
import { APP_VERSION, IOS_APP_LINK, RETAIL_LINK } from './shared/constants/constants';
import { DOCUMENT } from '@angular/common';
import { OffersAllPageResponseData, OfferResponseData } from './shared/interfaces/offer';
import { CustomjsService } from './shared/service/customjs.service';
import { CorpOfferListingData, CorpOfferResponseData } from './shared/interfaces/corp-offer';

interface SearchResult {
  name: string,
  file: string
  slug: string
}

@Component({
  selector: 'bevvi-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

  title = 'bevvi-b2b-new';

  public appLink: string = IOS_APP_LINK
  createSearchForm: FormGroup;
  createNewLetterSubscribeForm: FormGroup;
  createCouponForm: FormGroup;

  public isUserLoggedIn: boolean = true;
  public isLocationPresent: boolean = false;
  public userDeliveryAddress: DeliveryAddress;
  public cartQty: number;
  public username: string;
  public searchText: string = "";
  private notUse: boolean = false;
  public showLogin: boolean = false;
  public loginURL: string;
  public showFooter: boolean = true;
  public webLink = RETAIL_LINK + '';

  @ViewChild('coupon', { static: false })
  public couponRef: ElementRef;

  @ViewChild('couponDismiss', { static: false })
  public couponDismissRef: ElementRef;

  @ViewChild('showSearch', { static: false })
  public showSearchRef: ElementRef;

  @ViewChild('searchTextDesktop', { static: false })
  public searchTextDesktopRef: ElementRef;

  @ViewChild('searchTextMobile', { static: false })
  public searchTextMobileRef: ElementRef;

  private isSubmit: boolean = true;
  public formSubmit: boolean = false;
  public existingVersion: string;
  private hubSopt: any;

  private remarkety_subscribe: any;
  private remarkety_set: boolean = false;

  public textChange: boolean = false;
  public textBanner: string = 'SEND YOUR FAVORITE DRINKS TO YOUR TEAM OR CLIENTS, NO MINIMUM !!!!!';
  public searchValue: Array<SearchResult> = [];
  public emptySearch: boolean = false;
  public removeHeader: boolean = false;
  public isRecipientPage: boolean = false;

  constructor(
    private apiService: ApiService,
    private localStorage: LocalStorageService,
    private userService: UserService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private customJS: CustomjsService
  ) {

  }

  ngOnInit() {
    // this.couponRef.nativeElement.click();

    // Check Version
    let runningVersion = this.localStorage.getAppVersion();
    this.existingVersion = APP_VERSION;

    if (runningVersion === null) {
      this.localStorage.clearLocalStorage();
      this.localStorage.setAppVersion(this.existingVersion);
    } else if (runningVersion != this.existingVersion) {
      this.localStorage.setAppVersion(this.existingVersion);
    } else if (runningVersion === this.existingVersion) {
      ;
    } else {
      this.localStorage.clearLocalStorage();
      this.localStorage.setAppVersion(this.existingVersion);
    }
    this.isUserLoggedIn = (this.localStorage.getCurrentAccountID() && this.localStorage.getAccessToken()) ? true : false;
    this.username = this.localStorage.getAccountUsername();

    // console.log(this.route.snapshot)
    // console.log(this.route.url);

    this.userService.username$
      .subscribe(
        data => {
          this.isUserLoggedIn = (this.localStorage.getCurrentAccountID() && this.localStorage.getAccessToken()) ? true : false;
          if (this.isUserLoggedIn) {
            this.username = data;
          }
        }
      );

    this.userService.cartQty$
      .subscribe(
        (cartQty: number) => {
          this.cartQty = cartQty;
        }
      );
    // check if locaiton is present
    this.isLocationPresent = (this.localStorage.getUserSearchGeoLocationAddress()) ? true : false;
    this.userService.locationPresent$
      .subscribe(
        (data: boolean) => {
          this.isLocationPresent = this.localStorage.getUserSearchGeoLocationAddress() ? true : data;
        }
      );
    this.getCartQuantity();
    this.initForm();

    this.userService.loginButton$
      .subscribe(
        (data: boolean) => {
          this.showLogin = data;
          // console.log('CAN SHOW LOGIN: ' + this.showLogin);
        }
      )

    this.hubSopt = this._renderer2.createElement('script');
    this.hubSopt.text = 'text/javascript';
    this.hubSopt.id = 'hs-script-loader';
    this.hubSopt.async = 'true';
    this.hubSopt.defer = 'true';
    this.hubSopt.src = '//js.hs-scripts.com/4303637.js';
    this._renderer2.appendChild(this._document.body, this.hubSopt);

    this.userService.topBannerSubject
      .subscribe((data: string) => {
        data != '#BlackLivesMatter' ? this.textBanner = data : this.textBanner = this.textBanner;
        data != '#BlackLivesMatter' ? this.textChange = true : this.textChange = true;
      });

    this.userService.loginURLSubject
      .subscribe((data: string) => {
        this.loginURL = data;
      })

    this.userService.showFooterSubject
      .subscribe(
        (data: boolean) => {
          this.showFooter = data;
        }
      );

    this.userService.clearSearchStringSubject
      .subscribe(
        (flag: boolean) => {
          // console.log('HELLO')
          if (flag) {
            this.searchText = null;
            this.searchTextMobileRef.nativeElement.value = '';
            this.searchTextDesktopRef.nativeElement.value = '';
            this.userService.clearSearchText(false);
            console.log(this.searchText);
          }
        }
      )

    this.userService.isLoginSignUpPageSubject
      .subscribe(
        (flag: boolean) => {
          if (flag) {
            this.removeHeader = true;
          } else {
            this.removeHeader = false;
          }
        }
      )

    this.userService.isRecipientPageSubject
      .subscribe(
        (flag: boolean) => {
          console.log('Recipient', flag)
          if (flag) {
            this.isRecipientPage = true;
          } else {
            this.isRecipientPage = false;
          }
        }
      )
  }

  // ngAfterViewInit() {
  //   console.log('CLicked')
  //   if (!this.notUse) {
  //     this.couponRef.nativeElement.click();
  //   }
  // }

  /**
   * Initialise Form
   */
  initForm() {
    // Search Form
    this.createSearchForm = this.fb.group({
      search: [''],
    });

    // New Letter Subscribe Form
    this.createNewLetterSubscribeForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.minLength(5)]]
    });

    // Coupon Form
    // this.createCouponForm = this.fb.group({
    //   email: ['', [Validators.required, Validators.email, Validators.minLength(5)]]
    // });
  }

  get search() {
    return this.createSearchForm.get('search');
  }

  get email() {
    return this.createNewLetterSubscribeForm.get('email');
  }

  get couponEmail() {
    return this.createCouponForm.get('email');
  }

  subscribeNewsLetter() {
    let email: string = this.createNewLetterSubscribeForm.value['email'];

    if (email) {
      let data = {
        userType: 'consumer',
        email: email,
      };

      this.apiService.postData(this.apiService.constants.SUBSCRIBE_NEWSLETTER, data, '', false)
        .subscribe(data => {
          // console.log(data);
          this.createNewLetterSubscribeForm.reset();
          this.remarketySubscribe(email);
          alert('Thanks for subscribing')
        })
    }
  }

  remarketySubscribe(email) {
    this.remarkety_set = true;
    this.remarkety_subscribe = this._renderer2.createElement('script');
    this.remarkety_subscribe.text = 'application/json';
    this.remarkety_subscribe.id = 'subscribe_newsletter';
    this.remarkety_subscribe.async = true;
    this.remarkety_subscribe.defer = true;
    this.remarkety_subscribe.text = `
      var eventType = "newsletter/subscribe";

      var data = JSON.stringify({
        "email": "${email}"
      });
      _rmData.push(['track', eventType, data]);
    `;

    this._renderer2.appendChild(this._document.body, this.remarkety_subscribe);
  }

  getCartQuantity() {
    this.cartQty = this.localStorage.getCartQuantityFromLocalStorage();
  }

  public doSearch() {
    let search = this.createSearchForm.value['search'];
    console.log(search);
    if (search) {
      console.log(this.userService.setFilterView)
      this.userService.setFilterView = [{
        filters: {},
        filterMatrix: {
          row: -1,
          column: -1
        }
      }]
      this.userService.setSortView = 1;
      this.userService.productListingState = false;

      // this.createSearchForm.reset();
      // console.log(this.userService.setFilterView)
      // console.log('SEARCH TO: ' + search)
      this.customJS.searchPop('close-delay');
      this.searchValue = [];
      this.router.navigate(['/productlisting'], { queryParams: { search: search, sortBy: 'high', page: 1 } });
      this.createSearchForm.reset();
    }
  }

  public clearSearch() {
    this.searchText = '';
    this.searchTextMobileRef.nativeElement.value = '';
    this.searchTextDesktopRef.nativeElement.value = '';
    this.router.navigate(['/productlisting']);
  }

  public logoutUser() {
    let data = {
      'accessToken': this.localStorage.getAccessToken()
    }

    this.isUserLoggedIn = false;
    this.isLocationPresent = false;
    this.cartQty = null;
    this.apiService.postData(this.apiService.constants.LOGOUT_API, '', data, true)
      .subscribe(
        data => {
          this.router.navigate(['/']);
          this.localStorage.unsetLocalStorage();
        },
        error => {
          if (error.message == 'Authorization Required' || error.message == 'Invalid Access Token' || error.statusText == 'Unauthorized') {
            this.router.navigate(['/login']);
            this.localStorage.unsetLocalStorage();
          }
        }
      );
  }

  routePagination(slug) {
    this.searchTextDesktopRef.nativeElement.value = '';
    // this.createSearchForm.reset();
    this.searchValue = [];
    this.customJS.searchPop('close');
    this.clearText();
    this.router.navigate(['/productdetail', slug]);

  }

  // submitEmailForCoupon() {
  //   console.log('Submitting coupon');
  //   if (this.isSubmit && !this.notUse) {
  //     this.isSubmit = !this.isSubmit;
  //     if (this.createCouponForm.invalid) {
  //       console.log(this.createCouponForm.invalid)
  //       this.isSubmit = !this.isSubmit;
  //       this.formSubmit = true;
  //       return;
  //     }
  //     let email: string = this.createCouponForm.value['email'];

  //     if (email) {
  //       let data = {
  //         userType: 'coupon',
  //         email: email,
  //       };

  //       this.apiService.postData(this.apiService.constants.SUBSCRIBE_NEWSLETTER, data, '', false)
  //         .subscribe(data => {
  //           console.log(data);
  //           this.createCouponForm.reset();
  //           this.couponDismissRef.nativeElement.click();
  //         })
  //     }
  //   }
  // }

  dismissCoupon() {
    this.notUse = true;
  }

  clearText() {
    this.searchText = '';
    this.searchTextDesktopRef.nativeElement.value = '';
    this.searchTextMobileRef.nativeElement.value = '';
    this.customJS.searchPop('close');
  }

  searchProduct(value) {
    this.customJS.searchPop('close');
    if (value === 'desktop') {
      this.searchText = this.searchTextDesktopRef.nativeElement.value;
    } else if (value === 'mobile') {
      this.searchText = this.searchTextMobileRef.nativeElement.value;
    }
    // console.log(this.searchText);
    this.searchValue = [];
    if (this.searchText.length > 2) {
      // console.log('search')
      let params: object;
      let URL: string;
      let establishmentIDData = this.localStorage.getEstablishmentIDofAddress()
      if (this.isUserLoggedIn) {
        params = {
          currentAccountId: this.localStorage.getCurrentAccountID(),
          emailId: this.localStorage.getAccountEmail(),
          establishmentsID: JSON.stringify(establishmentIDData),
          offersPerPage: 5,
          currPage: 1,
          sort: 1,
          categoryType: 'ALL',
          displayName: null,
          value: null,
          searchBy: this.searchText,
          filtersData: ''
        };

        // URL = this.apiService.constants.GET_ALL_OFFER_ACCOUNTID_API;
      } else {
        let geoLocationInfo = this.localStorage.getUserSearchGeoLocationPoint();

        params = {
          geoLocationParams: JSON.stringify(geoLocationInfo),
          establishmentsID: JSON.stringify(establishmentIDData),
          offersPerPage: 5,
          currPage: 1,
          sort: 1,
          categoryType: 'ALL',
          displayName: null,
          value: null,
          searchBy: this.searchText,
          filtersData: ''
        }

        // URL = this.apiService.constants.GET_ALL_OFFER_GEOLOCATION_API;
      }
      URL = this.apiService.constants.GET_ALL_CORPORATE_OFFERS_API
      this.apiService.getData(URL, params, true)
        .subscribe(
          (offersAllResponseData: CorpOfferResponseData) => {
            // this.customJS.searchPop('close');
            if (offersAllResponseData.offers.length === 0) {
              this.emptySearch = true;
            } else {
              this.emptySearch = false;
            }
            this.searchValue = [];
            // console.log(offersAllResponseData);
            offersAllResponseData.offers.forEach((offer: CorpOfferListingData) => {
              // console.log(offer)
              this.searchValue.push({
                name: offer.name,
                file: offer.image,
                slug: offer.slug
              })
            });
            // console.log(this.searchValue);
            // this.showSearchRef.nativeElement.click();
            if (value === 'desktop') {
              this.customJS.searchPop('open-desktop');
            } else {
              this.customJS.searchPop('open-mobile');
            }
          }
        );
    } else {
      this.customJS.searchPop('close');
    }


  }

  ngOnDestory() {
    this.userService.topBannerSubject.unsubscribe()
    if (this.remarkety_set) { this._renderer2.removeChild(this._document.body, this.remarkety_subscribe); }
  }
}
